import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "@reduxjs/toolkit";

import examssReducer from "./reducer";
import masterDataReducer from "./masterDataSlice";

// Combine all reducers
const rootReducer = combineReducers({
  exams: examssReducer,
  masterData: masterDataReducer,
});

export default configureStore({
  reducer: rootReducer,
});
